import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  // Typography,
  DialogTitle
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import ButtonLoader from '@components/system/ButtonLoader/ButtonLoader';
// interface for Confirmation Dialog props
interface NotificationToGuarantorDialogProps {
  open: boolean;
  title: string | React.ReactElement;
  description: string | React.ReactElement;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onClose(response: 'yes' | 'no' | 'cancel'): void;
  className?: any | Record<string, unknown>;
  loader?: boolean;
}

const NotificationToGuarantorDialog = (
  props: NotificationToGuarantorDialogProps
): React.ReactElement => {
  const {t} = useTranslation();

  // props de-structure
  const {open, onClose, title, description, className} = props;

  const [buttonsDisable, setButtonsDisable] = React.useState<boolean>(false);

  const handleClose = React.useCallback(
    (response: 'yes' | 'no' | 'cancel') => {
      if (typeof onClose === 'function') {
        onClose(response);
      }
    },
    [onClose]
  );

  return (
    <Dialog
      maxWidth={'md'}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={handleClose}
      aria-labelledby="confirm-dialog"
      aria-describedby="confirm-dialog">
      <DialogTitle disableTypography>{title}</DialogTitle>
      {description && <DialogContent dividers>{description}</DialogContent>}
      <DialogActions>
        <Button
          onClick={() => {
            setButtonsDisable(false);
            handleClose('cancel');
          }}>
          {t('COMMON.CANCEL')}
        </Button>
        <Button
          style={{...className}}
          disabled={buttonsDisable}
          onClick={() => {
            setButtonsDisable(true);
            handleClose('yes');
          }}>
          {buttonsDisable ? <ButtonLoader /> : t('COMMON.YES')}
        </Button>
        <Button
          onClick={() => {
            setButtonsDisable(false);
            handleClose('no');
          }}
          color="primary"
          variant={'contained'}>
          {t('COMMON.NO')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationToGuarantorDialog;
